import { jsx as _jsx } from "react/jsx-runtime";
import { useMediaQuery, useTheme } from "@mui/material";
import { useEffect } from "react";
import { ItemCardSlider } from "../../../../../Shared/components/CardLayout/ItemCardSlider";
import { ItemCard } from "../../../../../Shared/components/ItemCard/components/ItemCard";
import { usePriceFormat } from "../../../../../Shared/hooks/usePriceFormat/usePriceFormat";
import { clone } from "../../../../../Shared/utils/clone";
import { product_default_image } from "../../../../../Shared/utils/constants";
import { buildProductCardProps } from "../utils/buildProductCardProps";
import { useProduct } from "../hooks/useProduct";
/**
 * Product - Renders the Product module: A list of products in either a grid or slider with a header.
 * @param moduleConfig
 * @returns Product Module
 */
export const Product = ({ sequenceNumber }) => {
    const { baseImageUrl, CenterCards, dayOfWeek, enableCollapse, enableCustomerSorting, gridSpacing, HandleProductDecrement, HandleProductIncrement, HandleRenewSwitch, headerText, hideSectionTitle, isCustomizeModalOpen, isEditFlow, isGridLayout, isSubscription, paperSettings, productsToRender, ReconcileProducts, screenLG, screenMD, screenSM, screenXS, setIsCustomizeModalOpen, } = useProduct(sequenceNumber);
    // ensure only products for configured day filter are in cart
    // and that products can only be renewing if order is subscription
    useEffect(() => {
        ReconcileProducts();
    }, [dayOfWeek, isSubscription]);
    const theme = useTheme();
    const { formatPrice } = usePriceFormat();
    const tabletAndAbove = useMediaQuery(theme.breakpoints.up("md"), { noSsr: true });
    const cardsToRender = productsToRender === null || productsToRender === void 0 ? void 0 : productsToRender.map((product) => {
        if (product.productImages.length < 1) {
            product.productImages.push(product_default_image);
        }
        const cardProps = buildProductCardProps({
            product,
            baseImageUrl,
            isSubscription,
            isEditFlow,
            HandleProductIncrement,
            HandleProductDecrement,
            HandleRenewSwitch,
            isCustomizeModalOpen,
            setIsCustomizeModalOpen,
            formatPrice,
        });
        return clone(cardProps);
    });
    if (!(productsToRender === null || productsToRender === void 0 ? void 0 : productsToRender.length)) {
        return null;
    }
    return (_jsx(ItemCardSlider, { sequenceNumber: sequenceNumber, paperSetting: paperSettings, gridSpacing: gridSpacing, isGridLayout: isGridLayout || !tabletAndAbove, cardsPerRowXS: screenXS, cardsPerRowSM: screenSM, cardsPerRowMD: screenMD, cardsPerRowLG: screenLG, cardsToRender: cardsToRender.map((cardProps, index) => (_jsx(ItemCard, Object.assign({}, cardProps), index))), CenterCards: CenterCards, hideText: hideSectionTitle, shouldUseAccordion: true, isCollapsible: enableCollapse, isCollapseDisabled: cardsToRender && cardsToRender.length === 0, text: headerText, enableCustomerSorting: enableCustomerSorting, enableSuggestedSorting: false }));
};
